import { useMemo } from 'react';

import { useUserContext } from 'src/components/app/context/UserContext';

const useSurveyLogoAndName = () => {
  const { currentSurvey } = useUserContext();

  return useMemo(
    () => ({
      surveyLogo: currentSurvey?.logo || undefined,
      surveyName: currentSurvey?.name || undefined,
      showNameInHeader: currentSurvey?.showNameInHeader ?? true,
    }),
    [currentSurvey],
  );
};

export default useSurveyLogoAndName;
